import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import PruRoute from '../../../common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../common/constants';
import { PROSPECT_REFERRAL_BASE_PATH } from '../constants';
import ProspectReferralDetailPage from './Detail/ProspectReferralDetailPage';

const ProspectReferralRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect exact from={PROSPECT_REFERRAL_BASE_PATH} to={`${PROSPECT_REFERRAL_BASE_PATH}/detail`} />
      <PruRoute exact path={`${PROSPECT_REFERRAL_BASE_PATH}/detail`} component={ProspectReferralDetailPage} />
      <PruRoute exact path={`${PROSPECT_REFERRAL_BASE_PATH}/edit`} component={ProspectReferralDetailPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default ProspectReferralRoutes;
